module.exports = __webpack_public_path__ + "img/img_product_CCL_3.6f073401.jpg";